/**
 * @file
 * Behaviors for the Agency Page Form.
 */
!(function(Drupal, $) {
  'use strict';
  /**
   *
   * @type {Drupal~behavior}
   */

  Drupal.behaviors.agencyFormSelectionColor = {
    attach: function() {
      document
        .getElementById('edit-do-you-have-a-particular-it-need')
        .addEventListener('change', function() {
          if (this.selectedIndex === 0) {
            this.style.color = '#989898';
          }
          else {
            this.style.color = '#1b2b34';
          }
        });
    }
  };
})(Drupal, jQuery);
